/*
 *
 * Contact Form 7 — keep the submit button clickable even when the consent
 * checkbox is unchecked (CF7 "acceptance_as_validation: on" otherwise disables it),
 * then block submission and flag the checkbox if it is still unchecked on click.
 *
 */

export const contactFormAcceptance = () => {
    document.querySelectorAll(".contact-form .wpcf7-acceptance").forEach((acceptance) => {
        const input = acceptance.querySelector('input[type="checkbox"]');
        const form = acceptance.closest("form.wpcf7-form");
        if (!input || !form) return;

        const submit = form.querySelector(".wpcf7-submit");
        if (!submit) return;

        // CF7 "acceptance-as-validation" disables submit while unchecked — override it.
        const keepEnabled = () => {
            if (submit.disabled) submit.disabled = false;
        };
        keepEnabled();
        new MutationObserver(keepEnabled).observe(submit, {
            attributes: true,
            attributeFilter: ["disabled"],
        });

        // Capture phase — runs before CF7's submit handler; blocks submission when unchecked.
        submit.addEventListener(
            "click",
            (e) => {
                if (!input.checked) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    acceptance.classList.add("is-invalid");
                    input.setAttribute("aria-invalid", "true");
                }
            },
            true
        );

        input.addEventListener("change", () => {
            if (input.checked) {
                acceptance.classList.remove("is-invalid");
                input.setAttribute("aria-invalid", "false");
            }
        });

        form.addEventListener("wpcf7mailsent", () => {
            acceptance.classList.remove("is-invalid");
            input.setAttribute("aria-invalid", "false");
        });
    });
};
